import { DEBUG, PATH } from '../constants';


const base = PATH;
const debug = DEBUG;

export async function getAllParcours() {
    try {
      const response = await fetch(base + 'parcours');
      return await response.json();
    } catch (error) {
      console.error('Erreur getAllParcours', error);
      throw error;
    }
}
  
export async function getAllParcoursByVillage(v) {
    try {
        const response = await fetch(base + 'parcours/v/' + v);
        return await response.json();
    } catch (error) {
        console.error('Erreur getAllParcoursByVillage', error);
        throw error;
    }
}

export async function getParcours(p) {
    try {
        const response = await fetch(base + 'parcours/' + p);
        return await response.json();
    } catch (error) {
        console.error('Erreur getParcours', error);
        throw error;
    }
}

export async function getParcoursByQuestion(id) {
    try {
        
        const response = await fetch(base + 'parcours/q/' + id);
        return await response.json();
    } catch (error) {
        console.error('Erreur getParcours', error);
        throw error;
    }
}
    
export async function createParcours(villageId, parcoursName, lang, intro = '', outro = '', active = 1) {
    try {
        const authToken = localStorage.getItem("authToken"); 
        const response = await fetch(base + 'parcours/insert', {
            method: 'POST',
            credentials: "include", 
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}` 
            },
            body: JSON.stringify({
                nom: parcoursName,
                id_village: villageId,
                lang: lang,
                intro: intro,
                outro: outro,
                active: active
            }),
        });
        return await response.json();
    } catch (error) {
        console.error('Erreur createParcours:', error);
        throw error;
    }
}

export async function updateParcours(id, parcoursName, intro, outro, lang) { 
    try {
        const authToken = localStorage.getItem("authToken"); 
        const response = await fetch(base + 'parcours/update', {
        method: 'POST',
        credentials: "include", 
        headers: { 
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': `Bearer ${authToken}` 
        },
        body: new URLSearchParams({ nom: parcoursName, id: id, intro:intro, outro:outro, lang: lang }),
        });
        return await response.json();
    } catch (error) {
        console.error('Erreur createParcours', error);
        throw error;
    }
}

export async function deleteParcours(parcoursId) { 
    try {
        const authToken = localStorage.getItem("authToken"); 
        const response = await fetch(base + 'parcours/delete', {
        method: 'POST',
        credentials: "include", 
        headers: { 
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': `Bearer ${authToken}` 
        },
        body: new URLSearchParams({id: parcoursId }),
        });
        return await response.json();
    } catch (error) {
        console.error('Erreur createParcours', error);
        throw error;
    }
}

/**
 * Activer/désactiver un parcours
 */
export async function toggleParcours(id, active) {
    try {
        const authToken = localStorage.getItem("authToken");
        const response = await fetch(base + "parcours/toggle", {
            method: 'POST',
            credentials: "include",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify({ id, active })
        });

        return await response.json();
    } catch (error) {
        console.error('Erreur toggleParcours:', error);
        throw error;
    }
}

    